import { render, staticRenderFns } from "./EmployeeLeaveAttendanceWrapper.vue?vue&type=template&id=494892ae"
import script from "./EmployeeLeaveAttendanceWrapper.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveAttendanceWrapper.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLeaveAttendanceWrapper.vue?vue&type=style&index=0&id=494892ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports